import { useStaticData } from '@mc/static-data-react'
import type { FreeTrial as FreeTrialApi } from '@mc/api'

import { FREE_TRIAL_I18N_NAMESPACE, i18nInstance } from '../i18n'

const NO_TRIAL = {
  eligible: false,
  advocate: null,
  durationDays: 0,
  strings: { duration: '', durationShort: '', type: '' },
}

export const useFreeTrial = ({ isGift }: { isGift?: boolean } = {}) => {
  const { guestPass } = useStaticData<{
    guestPass?: FreeTrialApi
  }>()
  const trial = guestPass

  // If user is gifting in checkout, we should not show trial info
  if (isGift || !trial) {
    return { trial: NO_TRIAL }
  }

  return {
    trial: {
      ...(trial ?? NO_TRIAL),
      strings: getTrialStrings(trial),
    },
  }
}

const getTrialStrings = (trial: FreeTrialApi) => {
  const t = i18nInstance.getFixedT(null, FREE_TRIAL_I18N_NAMESPACE)
  const durationDays = trial?.durationDays ?? 0

  let key = 'days'
  if (durationDays <= 1) key = 'hours'
  if (durationDays >= 30) key = 'months'

  return {
    duration: t(`common.duration.${key}`, { duration: durationDays }),
    durationShort: t(`common.duration.short.${key}`, {
      duration: durationDays,
    }),
    type: trial.advocate
      ? t('guestPass.labels.base')
      : t('freeTrial.labels.base'),
  }
}
